import gql from 'graphql-tag';

export default gql`
mutation ($id: String!, $name: String!) {
    createEtlPackage(input: {
        id: $id
        name: $name
        version: 1 
        scale: 1
        objects: []
        matrix: [1, 0, 0, 1, 0, 0]
    }) {
        __typename
        id
        name
        version
        scale
        objects
        queries {
            __typename
          id
        }
        matrix
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackages/NewMutation.js